export default __webpack_public_path__ + "static/media/Rest API.b59dce64.png";